const FieldType = Object.freeze({
  ID: "ID",
  TYPE: "TYPE",
  IDENTITY: "IDENTITY",
  IDENTIFIER: "IDENTIFIER",
  FACILITY_ID: "FACILITY_ID",
  STRUCTURE_ID: "STRUCTURE_ID",
  PROPERTY_ID: "PROPERTY_ID",
  UNIT_UUID: "UNIT_UUID",
  UNIT_NUMBER: "UNIT_NUMBER",
  ORG_ID: "ORG_ID",
  NAME: "NAME",
  NAME_DISPLAY: "NAME_DISPLAY",
  TYPE_DISPLAY: "TYPE_DISPLAY",
  SUB_TYPE: "SUB_TYPE",
  SUB_TYPE_DISPLAY: "SUB_TYPE_DISPLAY",
  ORGANIZATION_TYPE: "ORGANIZATION_TYPE",
  ORGANIZATION_TYPE_DISPLAY: "ORGANIZATION_TYPE_DISPLAY",
  ADDRESS: "ADDRESS",
  STREET_1: "STREET_1",
  STREET_2: "STREET_2",
  NEIGHBORHOOD: "NEIGHBORHOOD",
  CITY: "CITY",
  COUNTY: "COUNTY",
  STATE: "STATE",
  STATE_ID: "STATE_ID",
  STATE_CODE: "STATE_CODE",
  POSTAL_CODE: "POSTAL_CODE",
  COUNTRY: "COUNTRY",
  COUNTRY_ID: "COUNTRY_ID",
  COUNTRY_CODE_2: "COUNTRY_CODE_2",
  COUNTRY_CODE_3: "COUNTRY_CODE_3",
  PHONE: "PHONE",
  EMAIL: "EMAIL",
  WEBSITE: "WEBSITE",
  CONTACT: "CONTACT",
  CONTACT_ID: "CONTACT_ID",
  CONTACT_NAME: "CONTACT_NAME",
  CONTACT_NAME_DISPLAY: "CONTACT_NAME_DISPLAY",
  CONTACT_POSITION_TYPE: "CONTACT_POSITION_TYPE",
  CONTACT_PHONE: "CONTACT_PHONE",
  CONTACT_EMAIL: "CONTACT_EMAIL",
  HOURS: "HOURS",
  HOURS_PRIMARY: "HOURS_PRIMARY",
  HOURS_OPEN: "HOURS_OPEN",
  HOURS_CODE: "HOURS_CODE",
  HOURS_DAYS: "HOURS_DAYS",
  TIME_ZONE: "TIME_ZONE",
  PROPERTY_SIZE: "PROPERTY_SIZE",
  INTERIOR_SIZE: "INTERIOR_SIZE",
  PARKING_ONSITE: "PARKING_ONSITE",
  PARKING_OFFSITE: "PARKING_OFFSITE",
  LANGUAGE: "LANGUAGE",
  LANGUAGE_ID: "LANGUAGE_ID",
  LANGUAGE_CODE: "LANGUAGE_CODE",
  LANGUAGE_DISPLAY: "LANGUAGE_DISPLAY",
  NOTES: "NOTES",
  SPECIALIZED: "SPECIALIZED",
  COORDINATES: "COORDINATES",
  LATITUDE: "LATITUDE",
  LONGITUDE: "LONGITUDE",
  ALTITUDE: "ALTITUDE",
  CENTROIDS: "CENTROIDS",
  LABELS: "LABELS",
  EXTENT: "EXTENT",
  AREA: "AREA",
  PERIMETER: "PERIMETER",
  RING_COUNT: "RING_COUNT",
  VERTEX_COUNT: "VERTEX_COUNT",
  BOUNDARY: "BOUNDARY",
  BOUNDARY_UPDATED: "BOUNDARY_UPDATED",
  FACILITY: "FACILITY",
  PARENT: "PARENT",
  CHILDREN: "CHILDREN",
  ASSOCIATED: "ASSOCIATED",
  RELATED: "RELATED",
  CREATED: "CREATED",
  UPDATED: "UPDATED",
  FILTER: "FILTER"
});
export default FieldType;